import { AccommodationRequestFilterState } from "../utils/accommodation-request-filter-state";

export function useInitialValues(): {
  emptyValues: AccommodationRequestFilterState | any;
  initialValues: AccommodationRequestFilterState | any;
} {
  const emptyValues = {
    text: "",
    sort: "createdOn_asc",
    responsiblePerson: [],
    senderIds: [],
    status: [],
    createdFromTo: {
      from: null,
      to: null
    }
  };

  const initialValues = {
    ...emptyValues
  };

  return {
    emptyValues,
    initialValues
  };
}
